import "./ProfileLocalization.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileLocalizationComponentController from "./ProfileLocalizationComponentController";

export default class ProfileLocalizationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            profile: "<",
        };
        this.controller = ProfileLocalizationComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Localization/ProfileLocalization.html";
    }
}

module("mmAuth").component("mmProfileLocalization", new ProfileLocalizationComponent());
